import styled from 'styled-components';
import { CustomFormItem } from '../../styles';

export const FormItemWrapper = styled(CustomFormItem)`
	.ant-form-item-explain-error {
		position: absolute;
		white-space: nowrap;
	}
`;
